import { atom } from "jotai";
import { authAtom } from "./auth.atoms";
import { IsAuthenticatedCheckUseCase } from "@/core/usecases/auth";
import { AuthRepository } from "@/infrastructure/repositories/auth";

export const setAuthAtom = atom(null, async (_get, set) => {
  set(authAtom, {
    isAuthenticated: null,
    isLoading: true,
    error: null,
  });

  const checkIsAuthenticated = async () => {
    try {
      const authRepository = new AuthRepository();
      const isAuthenticated = await new IsAuthenticatedCheckUseCase(authRepository).execute();
      set(authAtom, {
        isAuthenticated,
        isLoading: false,
        error: null,
      });
    } catch (error) {
      set(authAtom, {
        isAuthenticated: false,
        isLoading: false,
        error: error as Error,
      });
    }
  };
  checkIsAuthenticated();
});
